import { FILTER_SECTIONS } from '../model/filter-sections';

import FilterFooter from './FilterFooter';
import FilterSection from './FilterSection';

type Props = {
  onDone: () => void;
};

const FilterForm = ({ onDone }: Props) => {
  return (
    <div className="flex flex-col">
      <div className="max-h-96 overflow-y-auto p-2">
        {FILTER_SECTIONS.map((section) => (
          <FilterSection key={section.key} section={section} />
        ))}
      </div>
      <FilterFooter onDone={onDone} />
    </div>
  );
};

export default FilterForm;
